/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from "react";
import { IRegion } from "../../../../interfaces/regions"
import { useParams, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { useEntityNavigation } from "@/hooks/useEntityNavigation";
import useMounted from "../../../../hooks/mounted";
import { listRegions, showRegion, createRegion, updateRegion, deleteRegion } from "@/services/infrastructure/regionsService";
import { updateValue } from "@/utils/updateValue";
import { useEntityQueryParams } from "@/hooks/useEntityQueryParams";
import { useEntitySearch } from "@/hooks/useEntitySearch";

const DEFAULT_DATA: IRegion = {
  id: '',
  code: "",
  description: "",
  states: [],
  createdIn: undefined
};

export const useRegions = ({ filter: filterInitial, disabledShowId, includes = [], disabledGetAll, defaultLimit, idService: idServiceInitial }:{
  disabledGetAll?: boolean;
  disabledShowId?: boolean;
  defaultLimit?: number;
  filter?: Record<string, any>,
  includes?: string[],
  idService?: string
}) => {
  const { id, idService } = useParams();
  const localtion = useLocation();
  const [regions, setRegions] = useState<IRegion[]>([]);
  const [region, setRegion] = useState<IRegion>(DEFAULT_DATA);
  const { filter, handleFilter, page, setPage, limit, setLimit } =
    useEntityQueryParams({ filter: filterInitial, defaultLimit });
  const [totalItems, setTotalItems] = useState<number>(0);
  const { goEdit, goBack } = useEntityNavigation({ basePath: "/towermanagement/regions" });

  const [loading, setLoading] = useState<boolean>(false);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleRegion = (key: string, value: any, custom?: (v: any) => any) => {
    setRegion((curr: any) => {
      let newData = updateValue(curr, key, value);
      if (custom) newData = custom(newData);
      return { ...curr, ...newData };
    });
  };

  const getAll = ({ page = 1, limit }:  { page?: number;limit?: number}) => {
    setLoading(true);
    listRegions({ includes: [...includes], filter,  page, limit })
      .then(({ regions: listRegions, limit, currentPage, totalItems }) => {
        setRegions(listRegions);
        
        setLimit(Number(limit));
        setTotalItems(totalItems)
      })
      .finally(() => setLoading(false));
  };


  const search = useEntitySearch({
    list: listRegions,
    key: "regions",
    includes: ["idSite", ...includes],
    filter,
  });


  const get = ({ id }: { id: string | number }) => {
    setLoading(true);
    showRegion({ id })
      .then(({ region: regionsShow }) => {
        setRegion(regionsShow);
      })
      .finally(() => setLoading(false));
  };

  const create = () => {
    setLoading(true);
    createRegion({ region })
      .then(({ region: regionCreate }) => {
        toast.success(`Região criado com sucesso!`);
        goEdit(regionCreate.id!);
      })
      .finally(() => setLoading(false));
  };

  const update = () => {
    setLoading(true);
    updateRegion({ id: region.id!, region })
      .then(({ region: regionUpdate }) => {
        toast.success(`Região atualizado com sucesso!`);
        goEdit(regionUpdate.id!);
      })
      .finally(() => setLoading(false));
  };


  useMounted(() => {
    getAll({page, limit})
  }, [page, limit, filter])

  useEffect(() => {
    handleRegion('idService', idService || idServiceInitial);
    const isPage = localtion.pathname.includes('/towermanagement/regions');
    if (id && isPage && !disabledShowId) {
      if (id !== "new") get({ id: id });
      return;
    }
    if (!disabledGetAll) getAll({limit});
  }, []);

  return {
    regions,
    region,
    loading,
    setPage,
    setLimit,
    page,
    limit,
    goEdit,
    goBack,
    handleRegion,
    create,
    id,
    update,
    totalItems,
    search,
    handleFilter
  };
};
